import { NAME } from '@app/marketing/constants';

// Hooks
import { useTranslation } from 'next-i18next';
import { cn } from '@utils/cn';

// Types
export interface Props {
    logos: string[];
    className?: string;
}

const Logos = ({ logos, className }: Props) => {
    const { t } = useTranslation(NAME);

    return (
        <div className={cn('mt-28', className)} data-cy="logos">
            <h4 className="text-center text-lg font-semibold">{t('logo-headline')}</h4>
            <div className="mt-8 grid grid-cols-3 gap-4 sm:grid-cols-4 sm:gap-6 lg:grid-cols-6">
                {logos.map((logo) => (
                    <div
                        key={logo}
                        className="h-12 w-full bg-contain bg-center bg-no-repeat"
                        style={{ backgroundImage: `url(${logo})` }}
                    />
                ))}
            </div>
        </div>
    );
};

export default Logos;
